module.exports = __webpack_public_path__ + "assets/img/prize.5195682d.png";